import React, { FC } from 'react';
import Page from '@/common/containers/page/page';
import Container from '@/common/containers/container/container';
import classes from './tech-page.style.module.scss';
import Jumbotron from '@/common/components/core/jumbotron/jumbotron';

const Page403: FC = () => {
  return (
    <Page>
      <Jumbotron
        previousPage={'Главная'}
        previousPath={`/`}
        title={'Недостаточно доступа'}
      />
      <Container>
        <div>
          <div className={classes.title}>
            У вас нет прав для просмотра данного раздела. Если вы уверены, что
            произошла ошибка - обратитесь к администратору системы
          </div>
        </div>
      </Container>
    </Page>
  );
};

export { Page403 };
